import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { SvgGavel, Icon } from '@tmapy/style-guide';

const msg = defineMessages({
  tooltip: {
    id: 'newOrder.approvalIcon.tooltip',
    defaultMessage: 'Datová sada podléhá schválení.',
  },
});

export const ApprovalIcon: React.FC = () => {
  const intl = useIntl();
  return (
    <span className='sg-a-d-f sg-u-c-body-darkest'>
      <Icon element={<SvgGavel />} tooltip={intl.formatMessage(msg.tooltip)} />
    </span>
  );
};
